import * as React from "react";
import { Redirect } from 'react-router-dom';
import axios from "axios";
import { 
    Typography, 
    Grid, 
    FormControl, 
    InputLabel, 
    Input, 
    Button,
    Box,
    TextField,
    CssBaseline 
} from '@mui/material';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * handle user login and registration
 */
class LoginRegister extends React.Component {
    // run once component is created; contructor recieves props which are values passed into the component by its parent
    constructor(props) {
        // call parent class's constructor React.Component so component can access this.props
        super(props);

        this.login_field_input = this.login_field_input.bind(this);
        //this.login_field_input = this.login_field_input.bind(this);
        this.login_submission = this.login_submission.bind(this);
        this.new_login_submission = this.new_login_submission.bind(this);

        // define the initial state of the component
        this.state = {

            // display name of company and our purpose
            company_name: "",
            raison_detre1: "",
            raison_detre2: "",
            raison_detre3: "",

            // login credentials for existing account
            username: "",
            password: "",

            // login credentials for new account
            new_username: "", 
            email: "",
            new_password1: "",
            new_password2: "",

            // account details
            first_name: "",
            middle_name:"",
            last_name: "",
            university: "",
            company: "",
            occupation: "",
            blurb: "", // description of your intellectual background
            grades: "", // optional, A's in particular courses can boost you likelihood of virality
            linkedin: "", // optional
            resume_cv: "", // optional
            emails: "", // must confirm university/company affiliation with emails

            // show feedback messages to user after they attempt log in
            login_prompt: "",
            // show feedback messages to user after they attempt to register
            registration_prompt: "",

            // need for loading icon and freezing create account button after user presses it
            registrationLoading: false,

            // redirection to home screen after login or registration
            redirectToHome: false, 

            registrationComplete: false
        };
    }

    /*
    // handle input fields for username and password input update
    login_field_input = (event) => {
        const { name, value } = event.target;
        console.log(`Input changed: ${name} = ${value}`);
        this.setState({ [name]: value });
    };
    */
    login_field_input(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    // HTTP POST Request: Send form data to a URL and get a response back
    // process username and password login submission by sending HTTP POST request to server using Axios
    // form handeler for logging a user in
    // send logged in user to home page
    login_submission(event_obj) {
        // stop default behavior of html form submission which would reload the page
        event_obj.preventDefault();

        // pull username and password from component's state to use in login request
        const { username, password } = this.state;
        const signin_user = {         
            signin_name: username, password
        }; 

        // send POST request to /admin/login endpoint using axios
        //axios.post("/admin/login", signin_user)
        axios.post(
            "/admin/login",
            signin_user,
            {
                withCredentials: true 
            }
        )
            // handle success response from promise
            .then(response => {  
                this.setState({ 
                    login_prompt: response.data.message,
                    redirectToHome: true
                });
                this.props.onLoginUserChange(response.data);  
            })
            // handle error
            .catch(error => {   
                console.log(error.response.data.message);
                this.setState({ 
                    login_prompt: error.response.data.message 
                });
                this.props.onLoginUserChange(null);  
            }); 
    };

    renderRegisterField(label, stateKey, type = "text") {
        return (
            <TextField
            fullWidth
            label={label}
            name={stateKey}
            type={type}
            value={this.state[stateKey]}
            onChange={this.login_field_input}
            margin="normal"
            variant="outlined"
            sx={{
                "& .MuiInputBase-input": {
                color: "#FFFDF8"
                },

                "& .MuiInputLabel-root": {
                color: "#B8B8B8"
                },

                "& .MuiOutlinedInput-root": {
                backgroundColor: "#262626",
                borderRadius: "12px",

                "& fieldset": {
                    borderColor: "#555"
                },

                "&:hover fieldset": {
                    borderColor: "#999"
                },

                "&.Mui-focused fieldset": {
                    borderColor: "#FFFDF8"
                }
                }
            }}
            />
        );
    }

    // collect data for new user registration
    retrieve_new_user() {
        // collect registration info from state
        const new_user_obj = {
            signin_name: this.state.new_username, 
            email: this.state.email,
            password: this.state.new_password1,

            first_name: this.state.first_name,
            middle_name: this.state.middle_name,
            last_name: this.state.last_name,

            university: this.state.university,
            company: this.state.company,
            occupation: this.state.occupation,
            blurb: this.state.blurb,
            grades: this.state.grades,
            linkedin: this.state.linkedin,
            resume_cv: this.state.resume_cv,
            emails: this.state.emails,
        };

        // clears form by resetting all registration-related state fields
        this.setState({ 
            // login credentials for new account
            new_username: "", 
            email: "",
            new_password1: "",
            new_password2: "",

            // account details
            first_name: "",
            middle_name:"",
            last_name: "",
            university: "",
            company: "",
            occupation: "",
            blurb: "", // description of your intellectual background
            grades: "", // optional, A's in particular courses can boost you likelihood of virality
            linkedin: "", // optional
            resume_cv: "", // optional
            emails: "", // must confirm university/company affiliation with emails
        });
        
        // return gathered user data so that it can be sent to server
        return new_user_obj;
    }

    // handle new user registration when user submits the "create new account" form
    new_login_submission(event_obj) {
        // stop default behavior of html form submission which would reload the page
        event_obj.preventDefault();

        // pull new password from component's state to use in account creation request
        const { new_password1, new_password2 } = this.state;

        // check if new passwords match (after retyping the first one when creating account), reprompt if not
        if (new_password1 !== new_password2) {
            this.setState({ 
                registration_prompt: "Passwords do not match, try again" 
            }); 
            return;
        }

        // retrieve user data for registration
        const new_user = this.retrieve_new_user();

        // Show loading spinner
        this.setState({
            registrationLoading: true,
            registration_prompt: ""
        });

        // send data to server
        // send POST request to /user endpoint with axios
        //axios.post("/user", new_user) 
        axios.post(
            "/user",
            new_user,
            {
                withCredentials: true 
            }
        )
            // handle success response from promise to update registration prompt with message from server
            .then(response => {  
                //this.setState({ 
                //    registration_prompt: response.data.message,
                //    redirectToHome: true 
                //});
                this.setState({

                    registrationLoading: false,

                    registration_prompt:
                        response.data.message ||
                        "Check your email to verify your account",

                    registrationComplete: true,

                    redirectToHome: false,

                    new_username: "",
                    email: "",
                    new_password1: "",
                    new_password2: "",

                    first_name: "",
                    middle_name:"",
                    last_name: "",

                    university: "",
                    company: "",
                    occupation: "",

                    blurb: "",
                    linkedin: "",
                    resume_cv: "",
                    emails: ""
                });
            })
            // handle failure
            .catch(error => {

                this.setState({
                    registrationLoading: false,
                    registration_prompt:
                        error.response?.data?.message ||
                        "Something went wrong. Please try again."
                });

            });
    };

    // render individual form input fields with consistent structure and styling using Material-UI components to create styled inputs
    input_field(input, id, input_type, curr_val, required, autoFocus = false) {
        // return styled input field using MUI components
        return (
        <FormControl fullWidth>
            {/* InputLabel is the floating label for the input field */}
            <InputLabel htmlFor={id}>
                {input} {/* this is the label text shown above the input */}
            </InputLabel>

            {/* actual input element */}
            <Input
                name={id} // field name (e.g. "username")
                id={id} // id used for accessibility linking with the label
                autoFocus={autoFocus} // if true, input gets focus when form loads
                autoComplete="on" // let browser try to auto-fill from stored info
                type={input_type} // input type (e.g., "text", "password")
                value={curr_val} // controlled input value (from state)
                onChange={this.login_field_input} // handler for input changes
                required={required} // mark the field as required if needed
            />
        </FormControl>
        );
    }

    componentDidMount() {
        console.log("✅ LoginRegister component mounted");
    }

    render() {
        // get the loginUser prop passed in from the parent component
        const { loginUser, mode } = this.props;

        /*
        // if user is already logged in, redirect them to their user profile page
        if (loginUser) {
            return <Redirect from="/login-register" to={`/users/${loginUser._id}`} />;
        }
        */
       // redirect user to homepage once logged in
       if (this.state.redirectToHome) {
        return <Redirect to="/home" />;
        }

        // REGISTER PAGE
        if (mode === "register") {
            return (
                <>
    <CssBaseline />
            {/*<Box
                sx={{
                minHeight: "100vh",
                width: "100%",
                bgcolor: "#1A1A1A",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
                }}
            >*/}
            <Box
                sx={{
                    minHeight: "100vh",
                    width: "100%",
                    bgcolor: "#1A1A1A",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    flexDirection: "column",
                    py: 8,
                    px: { xs: 3, sm: 4 },
                }}
            >

                <Box
                component="form"
                onSubmit={this.new_login_submission}
                sx={{
                    width: "100%",
                    maxWidth: "500px",
                    display: "flex",
                    flexDirection: "column"
                }}
                >

                {/*<Button
                    //onClick={() => window.location.href = "/"}
                    onClick={() =>history.push("/")}
                    sx={{
                    color: "#FFFDF8",
                    mb: 3,
                    px: 0,
                    alignSelf: "flex-start"
                    }}
                >
                    ← Back
                </Button>*/}
                <Button
                    onClick={() => window.location.href = "/"}
                    sx={{
                        color: "#FFFDF8",
                        mb: 3,
                        minWidth: 0,
                        px: 0
                    }}
                >
                    <ArrowBackIcon />
                </Button>

                <Box
                    component="img"
                    src="/Colloquia_Logo.png"
                    alt="Company Logo"
                    sx={{
                    width: 140,
                    borderRadius: "12px",
                    mb: 4,
                    alignSelf: "flex-start"
                    }}
                />

                <Typography
                    sx={{
                    color: "#FFFDF8",
                    mb: 5,
                    fontSize: "2rem",
                    fontWeight: 300,
                    textAlign: "center"
                    }}
                >
                    Join the Intellectual Community
                </Typography>

                {this.renderRegisterField("New Username", "new_username")}
                {this.renderRegisterField(".edu / .ac.uk Email", "email", "email")}
                {this.renderRegisterField("Create Password", "new_password1", "password")}
                {this.renderRegisterField("Re-enter Password", "new_password2", "password")}
                {this.renderRegisterField("First Name", "first_name")}
                {this.renderRegisterField("Last Name", "last_name")}

                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={this.state.registrationLoading}
                    sx={{
                        mt: 4,
                        py: 1.8,
                        bgcolor: "#000",
                        color: "#FFFDF8",
                        borderRadius: "12px",

                        "&.Mui-disabled": {
                            bgcolor: "#333",
                            color: "#888"
                        }
                    }}
                >
                    {this.state.registrationLoading
                        ? "Creating Account..."
                        : "Create Account"}
                </Button>

                {this.state.registrationLoading && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 3
                        }}
                    >
                        <CircularProgress
                            size={32}
                            thickness={4}
                            sx={{
                                color: "#FFFDF8"
                            }}
                        />
                    </Box>
                )}

                {this.state.registration_prompt && (
                    <Typography
                        sx={{
                            mt: 3,
                            color: "#FFFDF8",
                            textAlign: "center",
                            fontSize: "0.95rem",
                            opacity: 0.9
                        }}
                    >
                        {this.state.registration_prompt}
                    </Typography>
                )}

                </Box>

            </Box>
            </>
            );
        }
        // fxn that dynamically renders a login or registration form layout using MUI
        /**
         * title: the heading for the form (e.g., "Log In", "Create Account")
         * fields: an array of field objects (each with label, name, type, etc.)
         * submitHandler: the function to call when the form is submitted
         * buttonText: text displayed on the submit button
         * prompt: a string message shown below the form (e.g., success/error)
         * buttonDisabled: boolean to enable/disable the submit button
         * */
        const render_form = (title, fields, submitHandler, buttonText, prompt, buttonDisabled) => {
            console.log("Rendering form:", title);

            return (
                // use MUI's Grid component to layout the form: container with vertical layout, 
                // center-aligned, and set to occupy 6/12 (half) of the horizontal space
                <Grid container item direction="column" alignItems="center" xs={6}>

                {/* render the form title using Typography with h5 variant styling */}
                <Typography variant="h5">{title}</Typography>

                {/* inner grid item to contain the form, taking up 8/12 of width */}
                <Grid item xs={8}>
                    {/* start HTML form element, bind submit event to the handler */}
                    <form onSubmit={submitHandler}>
                        {/* Loop through each field configuration and render an input field */}
                        {fields.map((
                            { label, name, type, value, required = false, autoComplete = false }
                        ) =>
                            // Call a component method to render each input field
                            this.input_field(label, name, type, value, required, autoComplete)
                        )}

                        {/* Line breaks for visual spacing */}
                        <br/><br/>

                        {/* submit button with MUI styling */}
                        <Button
                            type="submit" // makes this a submit button
                            disabled={buttonDisabled} // disables button based on passed condition
                            fullWidth // makes the button span the full width
                            variant="contained" // applies a solid background
                            color="primary" // uses theme's primary color
                        >
                            {buttonText}
                        </Button>

                        {/* Line breaks for visual spacing */}
                        <br/><br/>

                        {/* conditionally render a prompt message (if present) */}
                        {prompt && (
                            <Typography 
                                style={{
                                    // set text color based on whether the prompt contains 'successfully'
                                    color: prompt.includes("successfully") ? "green" : "red" 
                                }}
                            >
                            {prompt} 
                            </Typography>
                        )}

                    </form>
                </Grid>
                </Grid>
            );
        };

        // configure login form input for users with accounts
        const login_fields = [
            // input field for username
            {
                //label: "Username", // label shown to user above text box
                //label: "Username or .edu/.ac.uk Email", // ⭐ CHANGED
                label: "Username or exact verified .edu/.ac.uk email you registered with",
                name: "username", // name attribute (used to identify input in form handeling)
                type: "text", // input type
                value: this.state.username, // current value pulled from component state
                required: true, // madatory field for form submission
                autocomplete: true // allow for autocomplete
            },

            // input field for password
            {
                label: "Password",
                name: "password",
                type: "password",
                value: this.state.password,
                required: true,
                autocomplete: true
            }
        ];

        // configure registration form input for new users
        const registration_fields = [
            // input field for new username
            { 
                label: "New Username", 
                name: "new_username", 
                type: "text", 
                value: this.state.new_username, 
                required: true 
            },

            // input field for email
            //{
            //    label: "Email", 
            //    name: "email",
            //    type: "text",
            //    value: this.state.email,
            //    required: true,
            //    autocomplete: true
            //},
            // Use email input type
           {
               label: ".edu / .ac.uk Email",
               name: "email",
               type: "email",
               value:
                 this.state.email,
               required: true
           },

            // input field for password
            { 
                label: "New Password", 
                name: "new_password1", 
                type: "password", 
                value: this.state.new_password1, 
                required: true 
            },

            // input field for password reentry to validate consistency
            { 
                label: "Re-enter Password", 
                name: "new_password2", 
                type: "password", 
                value: this.state.new_password2, 
                required: true 
            },

            // input field for first name
            { 
                label: "First Name", 
                name: "first_name", 
                type: "text", 
                value: this.state.first_name, 
                required: true 
            },

            // input field for middle name
            { 
                label: "Middle Name", 
                name: "middle_name", 
                type: "text", 
                value: this.state.middle_name, 
                required: false
            },

            // input field for last name
            { 
                label: "Last Name", 
                name: "last_name", 
                type: "text", 
                value: this.state.last_name, 
                required: true 
            },

            // input field for university
            { 
                label: "University", 
                name: "university", 
                type: "text", 
                value: this.state.university, 
                required: true 
            },

            // input field for company
            { 
                label: "Company", 
                name: "company", 
                type: "text", 
                value: this.state.company, 
                required: true 
            },

            // input field for occupation
            { 
                label: "What do you do?", 
                name: "occupation", 
                type: "text", 
                value: this.state.occupation, 
                required: true 
            },

            // input field for blurb
            { 
                label: "describe your intellectual background", 
                name: "blurb", 
                type: "text", 
                value: this.state.blurb, 
                required: true 
            },

            // input fields for university and work fields
            { 
                label: "we need to confirm university/company affiliation with emails", 
                name: "emails", 
                type: "text", 
                value: this.state.emails, 
                required: true 
            }
        ];
        
        console.log("LoginRegister render() mode:", mode);
        return (
            <>
    <CssBaseline />
     
            <Grid container>

                {
                    mode === "login" && render_form(
                        "Log In", // title shown above form
                        login_fields, // array of field configs for registration
                        this.login_submission, // handler for form submission
                        "Login", // submit button label
                        this.state.login_prompt, // feedback message (success/failure)
                        this.state.username.length === 0 // disable button if new username is empty
                    )
                }
            
            </Grid>
            </>
        );
    }

}

export default LoginRegister

/*
    // handle input fields for username and password input update
    login_field_input(event) {
        // DOM input element that triggered event (text box)
        const target = event.target;

        // name attribute from input element ("username", "password")
        const name = target.name;

        // current value that user has typed into input field
        const value = target.value;

        // dynamically update the corresponding field in state
        this.setState({
            [name]: value
        });
    };
    */

//login_field_input = ({ target }) => this.setState({ [target.name]: target.value });